import { useEffect } from 'react';
import { useSelectedCompany } from './useSelectedCompany';
import { applyTranslationOverrides, setTranslationType } from '@/lib/locales/translationOverrides';

/**
 * Hook that automatically applies translation overrides based on the effective company's translation type.
 * Uses effectiveCompany (selected company for super admins, user's company otherwise) so it works
 * both inside and outside SelectedCompanyProvider (e.g. in AuthProvider).
 */
export function useTranslationOverrides() {
  const { effectiveCompany, isInitialized } = useSelectedCompany();

  useEffect(() => {
    // Only apply overrides once the company selection is initialized
    if (!isInitialized) {
      return;
    }

    const translationType = effectiveCompany?.translationType;

    // Set the translation type for tracking
    setTranslationType(translationType);

    // Apply the overrides
    applyTranslationOverrides(translationType);
  }, [effectiveCompany?.translationType, effectiveCompany?.id, isInitialized]);
}
